export const environment = {
   production: true,
   api_url: 'https://api.smartcom.biz/api',
   server_url: 'https://api.smartcom.biz',
   app_url: 'https://smartcom.biz',
   URL : 'https://api.smartcom.biz/api',
   SERVER_URL : 'https://socket.smartcom.biz/'
 };


